import { isEmeisAIEnabled } from "../../utils/emeisAIFlag";
import { AiAssistantButton, AiAssistantPanel } from "./AiAssistantPanel";

/**
 * lawyal.ai at the app shell: the floating chat button and the panel it opens.
 * Both are there only while the "enableEmeisAI" switch is on.
 */
export function AiAssistantDock() {
  if (!isEmeisAIEnabled()) return null;

  return (
    <>
      <AiAssistantButton />
      <AiAssistantPanel />
    </>
  );
}
